import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 210E9002-74BB-44CB-9D93-7CC8EE95D519
 * name beaker-plus-outline
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/beaker-plus-outline.svg
 * tags
 * - Science 
 */
export const BeakerPlusOutlineIcon = createSvgIcon(<><path d="M18 14H20V17H23V19H20V22H18V19H15V17H18V14M3 3H21V5C19.9 5 19 5.9 19 7V12C18.3 12 17.63 12.12 17 12.34V5H7V7H12V8H7V9H10V10H7V11H10V12H7V13H12V14H7V15H10V16H7V19H13.08C13.2 19.72 13.45 20.39 13.8 21H7C5.9 21 5 20.11 5 19V7C5 5.9 4.11 5 3 5V3Z" /></>, 'BeakerPlusOutlineIcon');
export default BeakerPlusOutlineIcon